import { Pipe, PipeTransform, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'salesRate',
})

// 53 => 53%
// 53.25 => 53.3%
// 53.22 => 53.2%
export class SalesRatePipe implements PipeTransform {
  transform(value: number): string {
    if (!value || null) {
      return null;
    }

    const roundNum = value.toFixed(1);
    if (Number.parseInt(roundNum, 0) === Number(roundNum)) {
      return '' + Number.parseInt(roundNum, 0);
    }

    return roundNum;
  }
}
